import { httpClient, HttpMethod } from './http-client';
import { Address } from '../@types/address.type';

export const getCountries = (): Promise<Address[]> => {
  return httpClient<Address[]>('/countries', HttpMethod.Get);
};

export const getStatesByCountryId = (countryId: number): Promise<Address[]> => {
  return httpClient<Address[]>(`/states/country/${countryId}`, HttpMethod.Get);
};
